import React from 'react'

import { useWrapperContext } from 'components/Wrapper/Wrapper'
import { prHash } from 'pages/Contacts/Info/Info'
import { Link } from 'react-router-dom'
import { FormTypes } from 'models'

import styles from './Menu.module.scss'

type menuLinkType = {
  text: string | JSX.Element
  href?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const FooterMenu: React.FC<{ index: 0 | 1 }> = props => {
  const { setFormOpened } = useWrapperContext()

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    formType: FormTypes
  ) => {
    e.preventDefault()
    setFormOpened(formType)
  }

  const menuLinks: Array<menuLinkType[]> = [
    [
      {
        text: 'KION',
      },
      {
        text: 'О нас',
        href: '/about',
      },
      {
        text: 'KION Originals',
        href: '/catalog',
      },
      {
        text: 'Контакты',
        href: '/contacts',
      },
      {
        text: 'Пресс-служба',
        href: `/contacts${prHash}`,
      },
    ],
    [
      {
        text: 'Партнерство',
      },
      {
        text: 'Производство',
        href: '/production',
      },
      {
        text: 'Дистрибуция',
        href: '/distribution',
      },
      {
        text: 'Информационное партнерство',
        onClick: e => handleClick(e, FormTypes.Inform),
      },
      {
        text: 'Спонсорское партнерство',
        onClick: e => handleClick(e, FormTypes.Sponsor),
      },
    ],
  ]

  const renderLink = (link: menuLinkType) => {
    const _classes = `link ${styles.link}`
    const clickFn = link?.onClick
    if (clickFn) {
      return (
        <button className={_classes} onClick={e => clickFn(e)}>
          {link.text}
        </button>
      )
    }

    return (
      <Link className={_classes} to={link?.href || '/'}>
        {link.text}
      </Link>
    )
  }

  return (
    <>
      <ul className={styles['menu']}>
        {menuLinks[props.index].map((link, i) => (
          <li key={i} className={i === 0 ? styles.menu_title : ''}>
            {i === 0 ? link.text : renderLink(link)}
          </li>
        ))}
      </ul>
    </>
  )
}
